import ko from 'knockout';

export default class ViewModel {
  constructor({
    results = [],
    columns = [],
    totalCount,
    i18n,
  }) {
    this.results = ko.observable([]);

    this.totalCount = ko.observable(0);

    this.columns = columns;

    this.currentPageChangeCount = ko.computed(() => this.results().length);

    this.changeText = ko.observable('');

    this.changeText = ko.computed(() => {
      if (this.totalCount() === 0) {
        return i18n.getString('BulkEdit_Preview_NoChange');
      } else if (this.currentPageChangeCount() > 0) {
        return i18n.getString('BulkEdit_Preview_SomeChanges').replace('{0}', this.totalCount());
      }

      return i18n.getString('BulkEdit_Preview_NoCurrentPageChange').replace('{0}', this.totalCount());
    });

    this.updateResult = (resultsToUse, totalResultCount) => {
      this.results(resultsToUse);
      this.totalCount(totalResultCount || resultsToUse.length);
    };

    this.updateResult(results, totalCount);
  }
}
